// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont_info_cis-gs {
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.top_info_cis-gs {
  position: relative;
  display: block;
  height: 35%;
  width: 100%;
}
.row_info_cis-gs {
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: start;
  align-items: center;
}
/* .row_info_cis-gs:nth-child(odd) {
  background-color: #f8f9fa;
}
.row_info_cis-gs:nth-child(even) {
  background-color: #eeeeee;
} */
.title-info_cis-gs {
  position: relative;
  width: 13%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bolder;
  color: var(--main-color);
  font-size: var(--font-size-med);
}
.txt-info_cis-gs {
  position: relative;
  width: 87%;
  height: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  color: var(--txt-color);
  font-size:var(--font-size-xSmall) ;
}
.cel_row_info_cis-gs {
  position: relative;
  display: flex;
  width: 25%;
  height: 100%;
}
/* .cel_row_info_cis-gs:nth-child(even) {
  background-color: #f8f9fa;
}
.cel_row_info_cis-gs:nth-child(odd) {
  background-color: #eeeeee;
} */

/* .body_info_cis-gs {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 95%;
} */

.actBlanco {
  height: 4vh !important;
}
.react-select-container-admin-gs:hover{
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/portafolio-components/styles/InfoPortafolio.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;;;;GAKG;AACH;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;AACd;AACA;;;;;GAKG;;AAEH;;;;;;;GAOG;;AAEH;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB","sourcesContent":[".cont_info_cis-gs {\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.top_info_cis-gs {\r\n  position: relative;\r\n  display: block;\r\n  height: 35%;\r\n  width: 100%;\r\n}\r\n.row_info_cis-gs {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 20%;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n}\r\n/* .row_info_cis-gs:nth-child(odd) {\r\n  background-color: #f8f9fa;\r\n}\r\n.row_info_cis-gs:nth-child(even) {\r\n  background-color: #eeeeee;\r\n} */\r\n.title-info_cis-gs {\r\n  position: relative;\r\n  width: 13%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-weight: bolder;\r\n  color: var(--main-color);\r\n  font-size: var(--font-size-med);\r\n}\r\n.txt-info_cis-gs {\r\n  position: relative;\r\n  width: 87%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n  color: var(--txt-color);\r\n  font-size:var(--font-size-xSmall) ;\r\n}\r\n.cel_row_info_cis-gs {\r\n  position: relative;\r\n  display: flex;\r\n  width: 25%;\r\n  height: 100%;\r\n}\r\n/* .cel_row_info_cis-gs:nth-child(even) {\r\n  background-color: #f8f9fa;\r\n}\r\n.cel_row_info_cis-gs:nth-child(odd) {\r\n  background-color: #eeeeee;\r\n} */\r\n\r\n/* .body_info_cis-gs {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 95%;\r\n} */\r\n\r\n.actBlanco {\r\n  height: 4vh !important;\r\n}\r\n.react-select-container-admin-gs:hover{\r\n  cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
